// src/components/NavigationBar.js
import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { Menubar } from "primereact/menubar";
import logo from "../assets/logo.jpg";
import "../css/NavigationBar.css";

const NavigationBar = () => {
  const navigate = useNavigate();
  const { user, logout, hasPermission } = useContext(AuthContext);

  const navigateToLogin = () => navigate("/login");

  // Build vehicle submenu entries, filtering by permissions
  const vehicleItems = [
    { perm: "vehicles_dashboard", label: "Dashboard", icon: "pi pi-th-large", command: () => navigate("/pojazdy") },
    { perm: "vehicles_list", label: "Lista pojazdów", icon: "pi pi-list", command: () => navigate("/pojazdy/lista") },
    { perm: "vehicles_services", label: "Serwisy", icon: "pi pi-shield", command: () => navigate("/serwisy") },
    { perm: "vehicles_repairs", label: "Naprawy", icon: "pi pi-wrench", command: () => navigate("/naprawy") },
    { perm: "vehicles_faults", label: "Zgłoś usterkę", icon: "pi pi-exclamation-triangle", command: () => navigate("/zgloszenia") },
    { perm: "vehicles_workshop", label: "Warsztat", icon: "pi pi-wrench", command: () => navigate("/warsztat") },
    { perm: "vehicles_statistics", label: "Statystyki", icon: "pi pi-chart-bar", command: () => navigate("/statystyki") },
    { perm: "vehicles_settings", label: "Ustawienia", icon: "pi pi-cog", command: () => navigate("/ustawienia-pojazdow") },
  ].filter(item => hasPermission(item.perm));

  // WZ documents submenu
  const wzItems = [
    hasPermission("docs_list") && { label: "Lista dokumentów", icon: "pi pi-list", command: () => navigate("/dokumenty") },
    hasPermission("docs_create") && { label: "Dodaj nowy dokument", icon: "pi pi-plus", command: () => navigate("/dokumenty/nowy") },
    hasPermission("docs_stats") && { label: "Statystyki", icon: "pi pi-chart-bar", command: () => navigate("/dokumenty/statystyki") },
  ].filter(Boolean);

  const menuItems = [
    {
      label: "Dashboard",
      icon: "pi pi-home",
      command: () => navigate("/"),
    },
    wzItems.length > 0 && {
      label: "Dokumenty WZ",
      icon: "pi pi-file-edit",
      items: wzItems,
    },
    vehicleItems.length > 0 && {
      label: "Pojazdy",
      icon: "pi pi-car",
      items: vehicleItems,
    },
    hasPermission("admin_panel") && {
      label: "Panel admina",
      icon: "pi pi-cog",
      command: () => navigate("/admin"),
    },
  ].filter(Boolean);

  // Inicjały użytkownika do awatara
  const fullName =
    user && user.forname && user.name
      ? `${user.forname} ${user.name}`
      : user?.name || user?.username || "Użytkownik";
  // Etykieta roli po polsku (w bazie "User" przechowywane jako wartość)
  const roleLabel =
    user?.role === "User" || user?.role === "Użytkownik"
      ? "Użytkownik"
      : user?.role;
  const initials =
    (
      `${user?.forname?.[0] || ""}${user?.name?.[0] || ""}` ||
      user?.username?.[0] ||
      "U"
    )
      .toUpperCase()
      .trim() || "U";

  const brand = (
    <div className="app-brand" onClick={() => navigate("/")}>
      <img src={logo} alt="Logo" />
    </div>
  );

  const end = user ? (
    <div className="app-nav-end">
      <div className="app-user" title={fullName}>
        <div className="app-user-avatar">{initials}</div>
        <div className="app-user-info">
          <span className="app-user-name">{fullName}</span>
          <span className="app-user-role">{roleLabel}</span>
        </div>
      </div>
      <button
        className="app-logout-btn"
        title="Wyloguj"
        onClick={() => {
          logout();
          navigateToLogin();
        }}
      >
        <i className="pi pi-sign-out" />
      </button>
    </div>
  ) : null;

  return (
    <>
      {user ? (
        <header className="app-header">
          <Menubar
            className="app-menubar"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
            start={brand}
            end={end}
            model={menuItems}
          />
        </header>
      ) : null}
    </>
  );
};

export default NavigationBar;
